module.exports = __webpack_public_path__ + "static/img/employee-02-big.bd7b88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-02-big.png
// module id = OXaP
// module chunks = 2